<template>
  <div class="text-center">
      <h2>Error</h2>
      <p class="mt-3">予期せぬエラーが生じました。</p>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>